

export const tableData = {
  tHead: [
    {
      key: 'name',
      dataIndex: 'name',
      title: '一级指标',
      slot: 't1',
    },
    {
      key: 'region',
      dataIndex: 'region',
      title: '二级指标',
      width:150,
      slot: 't2',
    },
    {
      key: 'region',
      dataIndex: 'region',
      title: '三级指标',
      width:150,
      slot: 't3',
    },
    {
      key: 'level',
      dataIndex: 'level',
      title: '附件序号',
      slot: 't4',
    },
    {
      key: 'level',
      dataIndex: 'level',
      title: '附件名称',
      width:400,
      slot: 't5',
    },
    {
      key: 'level',
      dataIndex: 'level',
      title: '确认',
      slot: 't6',
      width:100,
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
